import React, { useEffect } from 'react';
import { Table } from 'js/components/common/Table';
import { compose, pick } from 'js/utils/ramda.util';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { withDynamicReducer, useDynamicReducerSelector } from './store';

export const W2GReportingFormBare = () => {
    const translate = useComponentTranslations();
    const { isLoading, error, isFetchError, winLoss: { amount = 0 } } = useDynamicReducerSelector(pick([
        'isLoading', 'error', 'isFetchError', 'winLoss'
    ]));
    const fetchComponent = hooks.useFetchComponent();
    const tableData = hooks.useTableData();
    const tableSummary = hooks.useTableSummary();
    const emptyTitle = translate(!Number(amount) ? 'data.empty' : 'transactions.empty');
    const {
        filters,
        headerValidate,
        headerInitialValues,
        anotherPeriodFilter,
        onAnotherPeriodApply
    } = hooks.useTableHeader();

    useEffect(() => {
        fetchComponent();
    }, [fetchComponent]);

    return (
        <Table
            error={error}
            filters={filters}
            isLoading={isLoading}
            tableData={tableData}
            emptyTitle={emptyTitle}
            tableSummary={tableSummary}
            headerValidate={headerValidate}
            showTableBody={Boolean(!isFetchError)}
            headerInitialValues={headerInitialValues}
            anotherPeriodFilter={anotherPeriodFilter}
            onAnotherPeriodApply={onAnotherPeriodApply}
        />
    );
};

export const W2GReportingForm = compose(
    withComponent({
        isForLoggedIn: true,
        tkPrefix: 'playtech.mobile.system.w2g-reporting-form.'
    }),
    withDynamicReducer()
)(W2GReportingFormBare);

componentService.registerWebContentComponents({ W2GReportingForm });
